
<script context="module">

  import SearchBar from 'components/search/SearchBar.svelte';
  export const viewNav = SearchBar;

</script>

<script>
  import { getContext, tick } from 'svelte';
  import { scale } from 'svelte/transition';

  import action from '~/action';
  import { getAllLocalizedData } from '~/data-utils';
  import SearchIndex from '~/search';
  import {
    searchTerm,
    searchMapFeatures,
    stores,
    newsAndEvent,
    offers,
    viewActive,
    viewPrev
  } from 'apps/imd/stores';

  import ItemScore from './ItemScore.svelte';
  import SearchResults from 'components/search/SearchResults.svelte';
  import ScrollContainer from 'components/ScrollContainer.svelte';
  import VirtualKeyboard from 'components/VirtualKeyboard.svelte';

  export let viewNavInstance;

  const app = getContext('app');

  let searchIndex;
  let autocomplete = [];
  let autocompleteResult = [];
  let searchResults = [];

  $: if ($stores && $offers) {
    Promise.all([
      app.service().facilities.getClosest(),
      $offers,
      getAllLocalizedData('storelist', 'stores'),
      $newsAndEvent
    ])
      .then(([facilities, offers, stores, newsAndEvent]) => {
        searchIndex = new SearchIndex({
          facilities: [facilities],
          offers: [$searchMapFeatures ? [] : offers],
          stores,
          news: [newsAndEvent]
        });
      })
      .catch(console.error);
  }

  function updateHistoryState () {
    history.replaceState({ searchTerm: $searchTerm }, 'state', `#${$viewActive}`);
  }

  // Setup on entering
  $: if ($viewActive == 'search' && /start|list|maps/.test($viewPrev)) {
    $searchMapFeatures = $viewPrev == 'maps';
  }

  // Search triggering
  $: if (searchIndex) {
    switch ($viewActive) {
    case 'search':
      ({
        tips: autocomplete,
        result: autocompleteResult
      } = searchIndex.autocomplete($searchTerm));
      updateHistoryState();
      break;

    case 'searchresults':
      searchResults = !$searchTerm ? [] :
        searchIndex.search($searchTerm);
      updateHistoryState();
      break;
    }
  }

  export function navBackToview () {
    const { searchTerm: currentState = '' } = history.state || {};
    $searchTerm = currentState;
  }

  async function completeWith ({ tip }) {
    if (tip != $searchTerm) {
      $searchTerm = tip;
    }
    await tick();
    action.goTo('searchresults');
  }

</script>

<ScrollContainer height="calc(100% - 136px)">
  {#if $viewActive == 'search'}
    <section class="search">

      <div class="autocomplete" data-testid="autocomplete">
        {#each autocomplete as item, index}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div class="autocomplete__tip"
            on:click="{() => completeWith(item)}"
            data-testid="autocomplete__tip{index}"
            transition:scale="{{duration: 200, opacity: 0.5, start: 0.5}}">
            {item.tip}
            <ItemScore
              word={item.tip}
              score={item.score}
              result={autocompleteResult[index]} />
          </div>
        {/each}
      </div>

      {#if viewNavInstance}
        <VirtualKeyboard value={searchTerm} input={viewNavInstance.input}
          on:click.enter="{() => action.goTo('searchresults')}"/>
      {/if}
    </section>
  {:else if $viewActive == 'searchresults'}
    <SearchResults {searchResults} />
  {/if}
</ScrollContainer>

<style>
  .autocomplete {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: 128px;
    margin: 32px 80px;
    overflow: hidden;
  }

  .autocomplete__tip {
    position: relative;
    height: 48px;
    margin: 8px;
    padding: 0 16px;
    background-color: var(--highlight);
    color: var(--textOnHighlight);
    font-size: 30px;
    white-space: nowrap;
  }

  .autocomplete__tip :global(.score) {
    bottom: -8px;
  }
</style>
